import { Select, SelectOption, SelectOptions } from '@pay-com/components'
import {
  Controller,
  FieldPath,
  FieldValues,
  useFormContext
} from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { getErrorMessage } from 'utils/get-error-message'

interface ControlledSelectProps<T extends FieldValues> {
  name: FieldPath<T>
  label?: string
  options: SelectOptions
  placeholder?: string
  disabled?: boolean
  isLoading?: boolean
  className?: string
}

export const ControlledSelect = <T extends FieldValues>({
  name,
  label,
  options,
  placeholder,
  disabled,
  isLoading,
  className
}: ControlledSelectProps<T>) => {
  const { control } = useFormContext<T>()
  const { t } = useTranslation('errors')

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const { error } = fieldState
        const currentValue =
          options.find(option => option.value === field.value) ?? null

        return (
          <Select
            value={currentValue}
            options={options}
            onChange={(option: SelectOption | null) => {
              field.onChange(option?.value ?? null)
            }}
            onBlur={field.onBlur}
            label={label}
            placeholder={placeholder}
            disabled={disabled || isLoading}
            error={Boolean(error)}
            errorMessage={getErrorMessage(t, error?.message)}
            size="medium"
            className={className}
            searchByLabelAndByValue
          />
        )
      }}
    />
  )
}
